import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { IdleTimeOutModal } from '../components/Modals/ModalSession';

const IdleTimeOutHandler = (props) => {
  const [showModal, setShowModal] = useState(false);
  const [isLogout, setLogout] = useState(false);
  let timer = undefined;
  const events = ['click', 'load', 'keydown', 'mousemove'];

  const eventHandler = (eventType) => {
    //console.log(eventType);
    if (!isLogout) {
      localStorage.setItem('lastInteractionTime', moment().toISOString());
      if (timer) {
        props.onActive();
        startTimer();
      }
    }
  };

  useEffect(() => {
    addEvents();

    return () => {
      removeEvents();
      clearTimeout(timer);
    };
  }, []);

  const startTimer = () => {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      let lastInteractionTime = localStorage.getItem('lastInteractionTime');
      const diff = moment.duration(moment().diff(moment(lastInteractionTime)));
      let timeOutInterval = props.inactivityTime
        ? props.inactivityTime
        : 3600000; // Default to 1 hour
      if (isLogout) {
        clearTimeout(timer);
      } else {
        if (diff.asMilliseconds() < timeOutInterval) {
          startTimer();
          props.onActive();
        } else {
          props.onIdle();
          setShowModal(true);
        }
      }
    }, props.inactivityTime ? props.inactivityTime : 3600000); // Default to 15 minutes
  };

  const addEvents = () => {
    events.forEach((eventName) => {
      window.addEventListener(eventName, eventHandler);
    });
      
    startTimer();
  };

  const removeEvents = () => {
    events.forEach((eventName) => {
      window.removeEventListener(eventName, eventHandler);
    });
  };

  const handleContinueSession = () => {
    setShowModal(false);
    setLogout(false);
  };

  const handleLogout = () => {
    removeEvents();
    clearTimeout(timer);
    setLogout(true);
    props.onLogout();
    setShowModal(false);
  };

  return (
    <div>
      <IdleTimeOutModal
        showModal={showModal}
        handleContinue={handleContinueSession}
        handleLogout={handleLogout}
      />
    </div>
  );
};

export default IdleTimeOutHandler;